import * as React from "react";
import { default as MaterialChip } from "material-ui/Chip";
import ToolTip, { ToolTipContent } from "components/ToolTip/ToolTip";
import { normal } from "../../fontWeights";
import { LocationDescriptor } from "history";
import { OctopusTheme, withTheme } from "components/Theme";
import { CSSProperties } from "@material-ui/styles";

const styles = require("./styles.less");

// @types/material-ui currently buggy. remove this if it ever works
interface ChipProps {
    className?: string;
    description?: string | ToolTipContent;
    onRequestDelete?: (event: object) => void;
    onClick?: (event: object) => void;
    backgroundColor?: string;
    labelColor?: string;
    markAsRemoved?: boolean;
    tabIndex?: number;
    avatar?: React.ReactNode;
    bordercolor?: string; // Had to use lowercase here because it's showing warnings otherwise ><
    style?: object;
    fullWidth?: boolean;
    noMargin?: boolean;
    to?: LocationDescriptor;
}

function buildStyle(theme: OctopusTheme, props: ChipProps): CSSProperties {
    return {
        lineHeight: "1.5rem",
        height: "1.5rem", // Specify height explicitly, or svg icons can push the container height out (eg. if you display
        // multiple chips in a row where some do/don't contain an avatar. E.g. environments list).
        margin: props.noMargin ? 0 : 4,
        display: "inline-flex",
        backgroundColor: props.backgroundColor || theme.chipBackground,
        borderWidth: props.bordercolor ? "0.0625rem" : "0",
        borderStyle: props.bordercolor ? "solid" : "none",
        borderColor: props.bordercolor ? props.bordercolor : "transparent",
        cursor: "inherit",
        verticalAlign: "middle",
    };
}

function buildLabelStyle(theme: OctopusTheme, props: ChipProps): CSSProperties {
    const markAsRemoved = props.markAsRemoved;

    return {
        lineHeight: "1.5rem",
        fontSize: "0.75rem",
        color: props.labelColor || theme.chipText,
        fontWeight: normal,
        maxWidth: props.fullWidth ? "none" : "12.5rem",
        textDecoration: markAsRemoved ? "line-through" : "none",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
    };
}

function buildDeleteIconStyle(theme: OctopusTheme, props: ChipProps): CSSProperties {
    return {
        margin: "0.0625rem 0.0625rem 0 0",
        width: "1.375rem",
        height: "1.375rem",
        fill: theme.iconNeutral,
    };
}

const Chip: React.FC<ChipProps> = props => {
    const { markAsRemoved, avatar, fullWidth, noMargin, bordercolor, ...rest } = props;
    const otherProps = { tabIndex: -1, ...rest };

    return withTheme((theme: OctopusTheme) => (
        <MaterialChip style={buildStyle(theme, props)} labelStyle={buildLabelStyle(theme, props)} deleteIconStyle={buildDeleteIconStyle(theme, props)} className={styles.chip} {...otherProps}>
            {avatar}
            <ToolTip content={<span>{props.description || props.children}</span>}>{props.children}</ToolTip>
        </MaterialChip>
    ));
};

export default Chip;
export { ChipProps };
